import React from "react";

const ProspectIntelligence = () => {
  return (
    <div className="about_area pb-30">
      <div className="container">
        <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3 text-left">
            
              <div className="section_main_title">
                <h2>Elevate Performance Through
<span>  Data-Led Precision</span></h2>
              
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
              <div className="section_content_text pt-4">
                <p>
                Ready to outpace competitors and drive revenue growth? ProPlus Data transforms complex data into precise, actionable intelligence. We provide real-time, curated intelligence that identifies high-value prospects, forecasts emerging opportunities, and empowers precise, impactful marketing. Our insights are designed to drive accuracy, elevate sales performance, and enable smarter, faster decisions.

                </p>
                <p> The cutting edge solutions and frameworks  empower you to target the right accounts, optimize strategies, and achieve operational excellence. With a focus on innovation and adaptability, we equip your business with the intelligence to thrive in a dynamic market.
                </p>
              </div>
            </div>
          
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="single_about_thumb mb-3">
              <div className="single_about_thumb_inner why-us">
                <img src="/assets/images/why-us.gif" alt="why proplus data" />
              </div>
            </div>
            
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default ProspectIntelligence;
